import { create } from "zustand";

const activeStore = create((set) => ({
  goal: null,
  focus: null,
  box: null,
  mood: null,
  setActive: (activeObject, type) => {
    set((state) => {
      return { [type]: activeObject };
    });
  },
  setAllActive: (goal, focus, box, mood) => {
    set((state) => {
      return { goal, focus, box, mood };
    });
  },
}));

export default activeStore;
